import type { AccountType } from '@witmetrics/utils';
import { ACCOUNT_TYPES } from '@witmetrics/utils/constants';
import { getLabLogoUrl, getPracticeLogoUrl } from '@witmetrics/utils/urls';

export const classes = {
  header:
    'flex h-14 items-center gap-[13px] rounded-[18px] border border-frame-border bg-headerbg px-4 shadow-store-header backdrop-blur-[24px] max-sm:gap-2.5 max-sm:px-3 dark:border-frame-border-dark dark:bg-headerbg-dark dark:shadow-store-header-dark',
  divider: 'h-[26px] w-px bg-hair dark:bg-hair-dark',
  storeLabel:
    'text-sm font-bold tracking-[0.14em] text-taupe-3 dark:text-mauve-2',
  spacer: 'flex-1',
  action:
    'flex cursor-pointer items-center gap-[7px] rounded-[11px] border-none bg-transparent px-3 py-2 text-[13px] font-semibold text-taupe-2 hover:bg-black/[0.06] dark:text-mauve-2 dark:hover:bg-white/[0.06]',
  themeToggle:
    'place-center size-[38px] cursor-pointer rounded-[11px] border-none bg-transparent text-taupe-2 hover:bg-black/[0.06] dark:text-mauve-2 dark:hover:bg-white/[0.06]',
  account:
    'flex cursor-pointer items-center gap-2.5 rounded-xl py-1 pl-1.5 pr-2 hover:bg-black/[0.06] dark:hover:bg-white/[0.06]',
  accountText: 'whitespace-nowrap text-left leading-tight',
  accountName: 'text-[13px] font-bold text-taupe-3 dark:text-mauve-1',
  accountPractice: 'text-[11px] text-taupe-1 dark:text-mauve-3',
  accountChevron: 'text-taupe-1 dark:text-mauve-3',
  headerButton: 'w-auto',
  testingWrapper:
    'text-orange-2 border border-orange-1 py-1 px-4 rounded-md max-sm:px-2 max-sm:text-xs',
  testingLink: 'ml-2 underline cursor-pointer font-medium',
};

// useActiveAccountLogo returns the raw stored logo value; build the URL for the active account's type (practice and lab logos live at different paths).
export function getActiveLogoUrl(
  accountType: AccountType | undefined,
  logo: string | undefined
): string | null {
  if (!logo) return null;
  if (accountType === ACCOUNT_TYPES.PRACTICE) return getPracticeLogoUrl(logo);
  if (accountType === ACCOUNT_TYPES.LAB) return getLabLogoUrl(logo);
  return null;
}
